export default __webpack_public_path__ + "static/media/oxetechwork_person_recortado.b9c6d838.png";